

export class OrganizationIntegrationRes {
    name: string;
    status: IntegrationStatus
}

export enum IntegrationStatus {
    Off = 0,
    Displayed = 1,
    On = 2
}